<template>
  <div class="stand-turn-page">

    <!-- ========== HEADER ========== -->
    <v-row align="center" class="stand-turn-header px-12">
      <v-col class="stand-turn-header__col">
        <v-icon class="stand-turn-header__back" @click="changePage">mdi-arrow-left</v-icon>
        <span class="stand-turn-header__title">{{ standActions.name || 'Caja' }}</span>
      </v-col>
    </v-row>
    <v-divider />

    <!-- ========== BODY: Two panels ========== -->
    <div class="stand-turn-body">

      <!-- ========== LEFT PANEL: Cues actives ========== -->
      <div class="queues-panel">
        <div class="queues-panel__title-wrapper">
          <span class="queues-panel__title">Colas activas:</span>
        </div>

        <div class="queues-panel__list">
          <!-- Queue card -->
          <div
            v-for="queue in tiquets"
            :key="queue.queue"
            :id="queue.queue"
            class="queue-card" :class="queue.switch !== false ? 'queue-card--active' : 'queue-card--inactive'"
          >
            <div class="queue-card__row">
              <!-- Icon -->
              <div class="queue-card__icon queue-card__icon--desktop">
                <v-icon v-if="queue.typeQueue == 1" :color="queue.switch !== false ? '#679940' : '#999'" size="26">mdi-human-male-male</v-icon>
                <v-icon v-if="queue.typeQueue == 2" :color="queue.switch !== false ? '#679940' : '#999'" size="26">mdi-ticket-outline</v-icon>
                <v-icon v-if="queue.typeQueue == 3" :color="queue.switch !== false ? '#679940' : '#999'" size="26">mdi-ticket-confirmation</v-icon>
              </div>
              <!-- Info -->
              <div class="queue-card__info">
                <p :id="queue.queue" class="queueIdSecondary queue-card__name" :class="queue.switch !== false ? 'queue-card__name--active' : 'queue-card__name--inactive'">{{ queue.nameQueue }}</p>
                <p class="queue-card__detail">Personas esperando: <strong :class="queue.switch !== false ? 'text-green' : 'text-gray-light'">{{ queue.pending }}</strong></p>
                <p class="queue-card__detail queue-card__detail--mb">Tiempo de espera: <strong :class="queue.switch !== false ? 'text-green' : 'text-gray-light'">{{ queue.waitTime || '0 m' }}</strong></p>
                <div class="queue-card__assign">
                  <v-btn
                    @click="queue.typeQueue == 1 ? createTicket() : assignTicketLeft(queue)"
                    :color="queue.switch !== false && queue.pending > 0 ? '#679940' : '#bbb'" dark depressed small rounded
                    :disabled="queue.switch === false || queue.pending <= 0"
                    class="queue-card__assign-btn"
                  ><v-icon small left>mdi-login</v-icon>ASIGNAR</v-btn>
                </div>
              </div>
              <!-- Switch + counter -->
              <div class="queue-card__switch queue-card__switch--desktop">
                <v-switch v-model="queue.switch" @change="closeTicketSwitch(queue)" hide-details dense
                  :loading="switchLoading[queue.queue]"
                  class="queue-card__switch-input"></v-switch>
                <v-progress-circular v-if="switchLoading[queue.queue]" indeterminate size="14" width="2" color="#679940" class="queue-card__loading"></v-progress-circular>
                <span v-else class="queue-card__status" :class="queue.switch !== false ? 'queue-card__status--active' : 'queue-card__status--inactive'">{{ queue.switch !== false ? 'Activa' : 'Cerrada' }}</span>
                <span class="queue-card__counter">{{ queue.attended || 0 }}/{{ queue.total || 0 }}</span>
              </div>
            </div>
          </div>

          <!-- Empty state -->
          <div v-if="tiquets.length === 0" class="queue-empty">
            <v-icon size="48" color="#ccc">mdi-playlist-remove</v-icon>
            <p class="queue-empty__text">No hay colas activas.</p>
          </div>
        </div>
      </div>

      <!-- ========== RIGHT PANEL: Turno actual + acciones ========== -->
      <div class="turn-panel-wrapper">
        <!-- Project logo -->
        <img
          v-if="projectDetail && projectDetail.logo"
          :src="`data:image/png;base64,${projectDetail.logo}`"
          alt="Logo"
          class="project-logo"
        />
        <div class="turn-panel">

          <!-- Greeting -->
          <p class="turn-greeting">
            Buenos días, estás en la <strong>{{ standActions.name || 'caja' }}</strong>
          </p>

          <!-- Current queue name -->
          <div class="turn-queue-name">
            <p v-if="tiquetQueue && !showbutton" class="turn-queue-name__text">
              Este turno pertenece a la cola de: <strong class="turn-queue-name__highlight">{{ tiquetQueue.nameQueue }}</strong>
            </p>
          </div>

          <!-- Turn number box -->
          <div class="turn-number-box" :class="showbutton ? 'turn-number-box--empty' : 'turn-number-box--active'">
            <p id="tiquetNum" v-if="!showbutton"
              class="turn-number turn-number--active">
              {{ tiquetNumber }}
            </p>
            <p v-if="showbutton"
              class="turn-number turn-number--empty">
              --
            </p>
          </div>

          <!-- Badge: Caja abierta -->
          <div class="turn-badge turn-badge--open">
            CAJA ABIERTA
          </div>
          
          <!-- Badge: Esperando turno -->
          <div v-if="showbutton" class="turn-badge turn-badge--waiting">
            ESPERANDO TURNO
          </div>

          <!-- Action buttons -->
          <div class="turn-actions">

            <!-- New (type 1) -->
            <v-btn v-if="queueType == 1 && !showbutton"
              @click="createTicket" color="#679940" dark depressed x-large block
              class="turn-btn turn-btn--primary">
              <v-icon left>mdi-plus</v-icon>NUEVO
            </v-btn>

            <!-- Previous + Next (type 2) -->
            <div v-if="queueType == 2 && !showbutton" class="turn-actions__row">
              <v-btn @click="deleteTicket" color="#acacac" dark depressed x-large
                class="turn-btn turn-btn--secondary">
                <v-icon left>mdi-skip-previous</v-icon>ANTERIOR
              </v-btn>
              <v-btn @click="createTicket" color="#679940" dark depressed x-large
                class="turn-btn turn-btn--secondary">
                <v-icon left>mdi-skip-next</v-icon>SIGUIENTE
              </v-btn>
            </div>

            <!-- Finish and next -->
            <v-btn v-if="showCreate == false && !showbutton"
              @click="closeAndNextTicket" outlined color="#679940" x-large block
              class="turn-btn turn-btn--outlined-green">
              <v-icon left size="26" color="#679940">mdi-close-circle</v-icon>
              FINALIZAR Y SIGUIENTE
            </v-btn>

            <!-- Cancel and next -->
            <v-btn v-if="showCreate == false && !showbutton"
              @click="cancelAndNextTicket" outlined color="#999" x-large block
              class="turn-btn turn-btn--outlined-gray">
              <v-icon left size="26" color="#999">mdi-cancel</v-icon>
              CANCELAR Y SIGUIENTE
            </v-btn>

          </div>

          <!-- Lamp indicator -->
          <div v-if="Lamp.idPlugin" class="turn-lamp">
            <v-icon large v-if="Lamp.TURN == 'on' && Lamp.COLOR == '255,0,0'" color="red">mdi-lightbulb-on-outline</v-icon>
            <v-icon large v-if="Lamp.TURN == 'on' && Lamp.COLOR == '0,255,0'" color="green">mdi-lightbulb-on-outline</v-icon>
            <v-icon large v-if="Lamp.TURN == 'off'">mdi-lightbulb-on-outline</v-icon>
          </div>

        </div>
      </div>

    </div>

    <!-- Snackbar -->
    <v-snackbar v-model="snackbar" :timeout="-1" color="#fd846d" left max-width="300" transition="slide-x-transition">
      <v-row>
        <v-col class="snackbar-close-col pa-0">
          <v-btn icon color="white" text @click="snackbar = false"><v-icon small>mdi-close</v-icon></v-btn>
        </v-col>
        <v-col class="px-0 py-2"><span class="pl-2">{{ text }}</span></v-col>
      </v-row>
    </v-snackbar>

    <!-- Reset dialog -->
    <v-dialog max-width="500px" v-model="dialogReset">
      <DialogConfirmReset
        :messages="['¿Está seguro? Esta acción reseteará el contador de la cola y empezará de nuevo por 0','Introduzca PIN para resetear']"
        @close-dialog="closeDialog"
        @complete-action="restartQueueLeft"
      />
    </v-dialog>

    <!-- Right menu drawer -->
    <v-navigation-drawer
      hide-overlay
      :disable-route-watcher="true"
      :value="showRightMenu"
      absolute
      :clipped="$vuetify.breakpoint.smAndUp"
      width="419"
      class="elevation-4 nav-drawer"
      right
      stateless
    >
      <RightMenuStandDetail v-if="RightMenuStandDetail" />
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import axios from "axios";
import router from "vue-router";
import RightMenuStandDetail from "@/components/RightMenuStandDetail.vue";
import DialogConfirmReset from "@/components/DialogConfirmReset.vue";

export default {
  name: "queues",
  components: {
    RightMenuStandDetail,
    DialogConfirmReset
  },
  data: () => ({
    snackbar: false,
    text: `Recuerde cerrar el ticket al finalizar (si no, éste seguirá contabilizando el tiempo).`,
    showCreate: true,
    switch1: true,
    tiquetQueue: null,
    components: {},
    deleteDialog: false,
    queuesStatus: [],
    datos: [],
    interVal: [],
    dialogReset: false,
    queueData: null,
    switchLoading: {},
    
  }),
  computed: {
    hasPendingTurns() {
      return this.tiquets.some(q => q.switch !== false && q.pending > 0);
    },
    tiquets() {
      return this.TiquetFirst.map((tiquet) => {
        const status =
          this.queuesStatus.find((s) => s.queue === tiquet.queue) ||
          {};
        const attended =
          this.TiquetAttended.find(
            (a) => a.queue === tiquet.queue
          ) || {};
        const ticketsClosed = attended.ticketsClosed || 0;
        const inProgress = tiquet.ticketNow ? 1 : 0;
        const total = ticketsClosed + tiquet.pending + inProgress;

        return {
          ...tiquet,
          switch: status.switch,
          attended: ticketsClosed,
          total: total,
        };
      });
    },

    showbutton() {
      let show = true;
      this.TiquetFirst.forEach((element) => {
        if (element.ticketNow != null) {
          show = false;
        }
      });
      return show;
    },
    tiquetNumber() {
      // console.log(this.TiquetFirst);
      //  console.log(this.actualTicket);

      this.TiquetFirst.forEach((element) => {
        if (element.ticketNow != null) {
          this.tiquetQueue = element;
        }
      });
      // console.log("tiquet");
      // console.log(this.tiquetQueue);
      if(document.getElementById('tiquetNum')!= null){        
        this.checkSize(this.tiquetQueue.ticketNow.ticket.length)
      }
      if (this.tiquetQueue != null) {
        if (this.tiquetQueue.ticketNow == null) {
          return "--";
        } else {
          return this.tiquetQueue.ticketNow.ticket;
          this.showCreate = false;
        }
      } else {
        return "---";
      }
    },
    queueType() {
      this.TiquetFirst.forEach((element) => {
        if (element.ticketNow != null) {
          this.tiquetQueue = element;
          this.showCreate = false;
        }
      });
      // console.log("type");
      // console.log(this.tiquetQueue);

      //  console.log(this.tiquetQueue.typeQueue);
      if (this.tiquetQueue != null) {
        if (this.tiquetQueue.typeQueue != null) {
          return this.tiquetQueue.typeQueue;
        }
      } else {
        return 3;
      }
    },
    queueId() {
      this.TiquetFirst.forEach((element) => {
        if (element.ticketNow != null) {
          this.tiquetQueue = element;
          this.showCreate = false;
        }
      });
      // console.log("Id");
      // console.log(this.tiquetQueue);
      if (this.tiquetQueue != null) {
        if (this.tiquetQueue != null) {
          return this.tiquetQueue.queue;
        }
      }
    },

    // arrQueues(){
    //   let idResource = this.standActions.idResource
    //   let arstands = this.allQueues
    //   let variable = arstands.filter(stand => stand.resources.includes(idResource))
    //   return variable
    // },
    ...mapState(["userData"]),
    ...mapState("app", ["projectDetail"]),
    ...mapState("queues", [
      "actualTicket",
      "RightMenuStandDetail",
      "showRightMenu",
      "TiquetFirst",
      "Tiquet",
      "standActions",
      "allQueues",
      "editedQueue",
      "allResouces",
      "TiquetAttended",
      "Lamp"
    ]),
    headers() {
      return [];
    },
  },
  methods: {
    ...mapActions("queues", [
      "assignTicketStoreLeft",
      "rightMenuTrueNewDeviceTableStore4",
      "closeTicketStore",
      "getTicketStore",
      "restartQueueStore",
      "deleteTicketStore",
      "createTicketStore",
      "assignTicketStore",
      "assignTicketStore2",
      "cancelnextStore",
      "cancelnextStore2",
      "closeNextStore",
      "closeNextStore2",
      "getTicketAttended",
    ]),
    ...mapMutations("queues", [
      "cleanTicketFirst",
      "openRightMenuMutation",
      "closeRightMenuMutation",
    ]),

    closeDialog() {
      this.dialogReset = false;
      this.queueData = null;
    },

    setQueueData(queue){
      this.queueData = queue;
      this.dialogReset = true;
    },

    checkSize(size){
      var element = document.getElementById('tiquetNum');

      if(size > 4 && element != null){
       element.style.fontSize = "4em"
      }else if (size > 5 && element != null){
        element.style.fontSize = "3.5em"
      }else if (size > 6 && element != null){
        element.style.fontSize = "3em"
      }else if (size > 7 && element != null){
        element.style.fontSize = "2.5em"
      }else if (size > 8 && element != null){
        element.style.fontSize = "2em"
      }else if (size > 9 && element != null){
        element.style.fontSize = "1.5em"
      }else if (size > 10 && element != null){
        element.style.fontSize = "1em"
      }

    },

    changePage() {
      this.$store.commit('queues/ActualTicket', []);
      this.$router.push({
        name: "ResumeSpace",
      });
      this.closeRightMenuMutation();
      this.tiquetQueue = null;
    },

    infoStand() {
      this.openRightMenuMutation();
      this.rightMenuTrueNewDeviceTableStore4();
    },

    async createTicket() {

      let ids = "";

      if(this.editedQueue.idQueue == undefined){
        if(document.getElementsByClassName('queueId')){
          var id= document.getElementsByClassName('queueIdSecondary')[0].getAttribute('id');        
        }else{
          var id= document.getElementsByClassName('queueId')[0].getAttribute('id');        
        }

        ids = [id, this.standActions.idResource];
      }else{
        ids = [this.editedQueue.idQueue, this.standActions.idResource];
      }
      this.checkSize(this.tiquetQueue.ticketNow.ticket.length);
      this.createTicketStore(ids);
    },

    deleteTicket() {

      let ids = "";

      if(this.editedQueue.idQueue == undefined){

        if(document.getElementsByClassName('queueId')){
          var id= document.getElementsByClassName('queueIdSecondary')[0].getAttribute('id');        
        }else{
          var id= document.getElementsByClassName('queueId')[0].getAttribute('id');        
        }

        ids = [id, this.standActions.idResource];
      }else{
        ids = [this.editedQueue.idQueue, this.standActions.idResource];
      }

      this.deleteTicketStore(ids);
    },
    async closeTicketSwitch(queue) {
      this.$set(this.switchLoading, queue.queue, true);
      if (queue.switch == false) {
        let ids = [queue.queue, this.standActions.idResource];
        await this.closeTicketStore(ids);
      }

      this.queuesStatus.map((tiquet) => {
        if (tiquet.queue == queue.queue) {
          tiquet.switch = queue.switch;
        }
      });
      this.$set(this.switchLoading, queue.queue, false);
    },
    async restartQueue() {
      let ids = [this.editedQueue.idQueue, this.standActions.idResource];
      this.restartQueueStore(ids);
    },
    async assignTicket() {
      let objFinal = {};
      let idsActivas = [];

      this.queuesStatus.forEach((element) => {
        if (element.switch == true) {
          idsActivas.push(element.queue);
        }
      });
      objFinal.idsQueues = idsActivas;
      objFinal.idQueueNow = this.queueId;
      objFinal.idResource = this.standActions.idResource;
      objFinal.action = "assign";

      if (objFinal.idQueueNow == undefined) {
        objFinal.idQueueNow = null;
      }
      await this.assignTicketStore2(objFinal);
      if (this.actualTicket.length != 0) {
        this.showCreate = true;
        this.snackbar = true;
      }
      this.getTicketStore(this.standActions.idResource);
    },
    async closeTicket() {
      let ids = [this.tiquetQueue.queue, this.standActions.idResource];
      await this.closeTicketStore(ids);
      await this.getTicketAttended(this.standActions.idResource);

      if (this.actualTicket.length != 0) {
        this.showCreate = true;
      }
      this.getTicketStore(this.standActions.idResource);
    },
    async closeAndNextTicket() {
      this.snackbar = true;
      await this.getTicketAttended(this.standActions.idResource);
      let objFinal = {};
      let idsActivas = [];

      this.queuesStatus.forEach((element) => {
        if (element.switch == true) {
          idsActivas.push(element.queue);
        }
      });
      objFinal.idsQueues = idsActivas;
      objFinal.idQueueNow = this.queueId;
      objFinal.idResource = this.standActions.idResource;
      objFinal.action = "next";

      await this.closeNextStore2(objFinal);
      if (this.actualTicket.length != 0) {
        this.showCreate = true;
      }
      this.getTicketStore(this.standActions.idResource);
    },
    async cancelAndNextTicket() {
      await this.getTicketAttended(this.standActions.idResource);
      let objFinal = {};
      let idsActivas = [];

      this.queuesStatus.forEach((element) => {
        if (element.switch == true) {
          idsActivas.push(element.queue);
        }
      });
      objFinal.idsQueues = idsActivas;
      objFinal.idQueueNow = this.queueId;
      objFinal.idResource = this.standActions.idResource;
      objFinal.action = "cancelnext";

      await this.cancelnextStore2(objFinal);
      if (this.actualTicket.length != 0) {
        this.showCreate = true;
      }
      this.getTicketStore(this.standActions.idResource);
    },

    async assignTicketLeft(queue) {
      let ids = [queue.queue, this.standActions.idResource];
      await this.assignTicketStoreLeft(ids);
      if (this.actualTicket.length != 0) {
        this.showCreate = false;
        this.snackbar = true;
      }
      this.getTicketStore(this.standActions.idResource);

      // this.quitFirst = false;
      // this.showCreate =false;
    },
   async restartQueueLeft() {
      let ids = [this.queueData.queue, this.standActions.idResource];
      await this.restartQueueStore(ids);
      this.getTicketStore(this.standActions.idResource);
      this.queueData = null
      this.dialogReset = false
    },

    createStatus() {
      this.TiquetFirst.forEach((element) => {
        this.queuesStatus.push(element);
        element.switch = true;
      });
    },
    async checkTickets() {
      this.datos = this.TiquetFirst;
      await this.getTicketStore(this.standActions.idResource);

      var num = 0;
      this.datos.forEach((element) => {
        if (this.TiquetFirst[num].pending - element.pending == 0) {
          // console.log("no hay cambios en la cola", element.nameQueue);
        } else {
          // console.log("se han añadido ", this.TiquetFirst[num].pending - element.pending, " tiquets en la cola", element.nameQueue);
          var elem = (document.getElementById(
            element.queue
          ).style.backgroundColor = "#c5f272");
          elem = document.getElementById(element.queue).style.transition =
            "0.2s";
          let new2 = setTimeout(this.clearColor, 2000, element.queue);
        }
        num++;
      });
    },

    clearColor(element){
      var elem = document.getElementById(element).style.backgroundColor="white";
    },

    checkPlugins(){
      if(this.standActions.plugins){
        this.standActions.plugins.forEach(pluguin => {
          if(pluguin.type == "LAMP"){
            this.lamp =  pluguin;
          }else{
            this.lamp =  [];
          }
        });
      }
    }
  },
  async created() {
    this.checkPlugins();
    setTimeout(() => {
      this.snackbar = true;
    }, 200);
    this.interVal = setInterval(this.checkTickets, 5000);
    await this.createStatus();
  },
  mounted() {
    if(this.tiquetQueue != null){
          this.checkSize(this.tiquetQueue.ticketNow.ticket.length)
    }
  },

  destroyed() {
    clearInterval(this.interVal);
    this.cleanTicketFirst();
  },
};
</script>

<style scoped>
/* ===== Page layout ===== */
.stand-turn-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background: #f5f5f5;
}
.stand-turn-header {
  background-color: #fff;
  flex-shrink: 0;
  flex-grow: 0;
  min-height: 60px;
}
.stand-turn-header__col {
  display: flex;
  align-items: center;
}
.stand-turn-header__back {
  cursor: pointer;
}
.stand-turn-header__title {
  margin-left: 12px;
  font-size: 28px;
  font-weight: 300;
  color: #777;
  white-space: nowrap;
}
.stand-turn-body {
  display: flex;
  flex: 1;
  overflow: hidden;
}

/* ===== Left panel: Queues ===== */
.queues-panel {
  width: 40%;
  min-width: 300px;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0 28px;
}
.queues-panel__title-wrapper {
  padding: 16px 20px 8px;
}
.queues-panel__title {
  font-size: 16px;
  color: #555;
  text-align: left;
  display: block;
}
.queues-panel__list {
  flex: 1;
  overflow-y: auto;
  padding: 4px 8px 16px;
}
.queue-card {
  background: #fff;
  border-radius: 12px;
  padding: 18px 16px;
  margin-bottom: 12px;
}
.queue-card--active {
  border: 1px solid #679940;
}
.queue-card--inactive {
  border: 1px solid #e0e0e0;
}
.queue-card__row {
  display: flex;
  align-items: flex-start;
}
.queue-card__icon {
  flex-shrink: 0;
  padding-top: 2px;
  margin-right: 10px;
}
.queue-card__icon--desktop {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.queue-card__info {
  flex: 1;
  min-width: 0;
}
.queue-card__name {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 5px;
  text-transform: uppercase;
  text-align: center;
}
.queue-card__name--active {
  color: #679940;
}
.queue-card__name--inactive {
  color: #333;
}
.queue-card__detail {
  font-size: 11px;
  color: #777;
  margin-bottom: 1px;
  text-align: center;
}
.queue-card__detail--mb {
  margin-bottom: 8px;
}
.queue-card__assign {
  text-align: center;
}
.queue-card__assign-btn {
  font-size: 11px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
.queue-card__switch {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
}
.queue-card__switch--desktop {
  min-width: 65px;
}
.queue-card__switch-input {
  margin: 0 !important;
  padding: 0 !important;
}
.queue-card__loading {
  margin-top: 4px;
}
.queue-card__status {
  font-size: 10px;
  margin-top: 4px;
}
.queue-card__status--active {
  color: #679940;
  font-weight: 600;
}
.queue-card__status--inactive {
  color: #999;
}
.queue-card__counter {
  font-size: 12px;
  color: #999;
  margin-top: 3px;
}
.queue-empty {
  text-align: center;
  padding: 40px 20px;
}
.queue-empty__text {
  color: #aaa;
  font-size: 13px;
  margin-top: 10px;
}

/* ===== Right panel: Turn ===== */
.turn-panel-wrapper {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 36px 28px;
  overflow-y: auto;
  background: #fff;
  position: relative;
  z-index: 1;
}
.turn-panel {
  max-width: 460px;
  width: 100%;
  text-align: left;
}
.turn-greeting {
  font-size: 15px;
  color: #666;
  margin-bottom: 4px;
}
.turn-queue-name {
  min-height: 37px;
  margin-bottom: 20px;
}
.turn-queue-name__text {
  font-size: 13px;
  color: #888;
  margin: 0;
}
.turn-queue-name__highlight {
  color: #679940;
}
.turn-number-box {
  border-radius: 14px;
  padding: 20px 12px;
  margin-bottom: 14px;
  min-height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.turn-number-box--active {
  background: #666;
}
.turn-number-box--empty {
  background: #f0f0f0;
}
.turn-number {
  margin: 0;
  line-height: 1;
}
.turn-number--active {
  font-size: 110px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 4px;
}
.turn-number--empty {
  font-size: 110px;
  font-weight: 300;
  color: #ccc;
}
.turn-badge {
  padding: 14px 16px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 18px;
  text-align: center;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.turn-badge--open {
  background: #e8f5e0;
  color: #679940;
}
.turn-badge--waiting {
  background: #eee;
  color: #999;
}
.turn-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.turn-actions__row {
  display: flex;
  gap: 10px;
}
.turn-btn {
  font-weight: 700;
  border-radius: 8px;
  min-height: 50px;
}
.turn-btn--primary {
  font-size: 15px;
}
.turn-btn--secondary {
  flex: 1;
  font-size: 14px;
}
.turn-btn--outlined-green {
  font-size: 15px;
  border: 1px solid #679940;
  background: #fff !important;
}
.turn-btn--outlined-gray {
  font-size: 15px;
  border: 1px solid #ccc;
  background: #fff !important;
  color: #777 !important;
}
.turn-lamp {
  margin-top: 20px;
}

/* ===== Utilities ===== */
.text-green {
  color: #679940;
}
.text-gray-light {
  color: #999;
  font-weight: 400;
}
.snackbar-close-col {
  max-width: fit-content;
}
.nav-drawer {
  height: calc(100vh - 50px);
  z-index: 100;
}
.project-logo {
  position: absolute;
  bottom: 20px;
  right: 20px;
  max-width: 180px;
  max-height: 180px;
  object-fit: contain;
  z-index: 0;
  pointer-events: none;
}

h5 {
  font-size: 12px;
  font-weight: 300;
  text-align: initial;
}
h3 {
  text-align: left;
  font-weight: 400;
  font-size: 16px;
  color: #aeaeae;
}
>>> .v-snack__content {
  padding-top: 0;
  padding-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/desktop/GeneralStandTurn.vue